import { Component, EventEmitter, HostBinding, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ChartElementOrientation, ChartElementSize, ChartValueInterface } from '../interfaces/chart.interface';

export interface BarChartValueInterface extends ChartValueInterface {
  percentage: number;
  tooltip: string;
}

@Component({
  standalone: false,
  selector: 'campus-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss'],
})
export class BarChartComponent implements OnInit, OnChanges {
  public barChartValues: BarChartValueInterface[];

  @Input() values: ChartValueInterface[];
  @Input() showTrack? = false;
  @Input() orientation?: ChartElementOrientation = 'horizontal';
  @Input() size?: ChartElementSize = 'small';
  @Input() usePercentage? = true;
  @Input() showTooltip? = true;

  @Output() clickChart = new EventEmitter<ChartValueInterface>();

  @HostBinding('class')
  get hostClasses(): string {
    return ['ui-bar-chart', `ui-bar-chart--${this.orientation}`, `ui-bar-chart--${this.size}`].join(' ');
  }

  @HostBinding('class.ui-bar-chart--has-caption-icon')
  hasCaptionIconClass: boolean;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.usePercentage || changes.values || changes.orientation) {
      this.barChartValues = this.convertToBarChartValues();

      if (changes.values && changes.values.currentValue) {
        this.hasCaptionIconClass = changes.values.currentValue.some((value) => value.icon);
      }
    }
  }

  ngOnInit() {
    //
  }

  public chartClicked(value: ChartValueInterface): void {
    this.clickChart.emit(value);
  }

  private convertToBarChartValues(): BarChartValueInterface[] {
    const values = this.values;
    if (!values) {
      return [];
    }

    if (this.usePercentage) {
      return values.map((value) => ({
        ...value,
        percentage: value.value,
        tooltip: this.composeTooltip(value),
        showTrack: value.hasValue,
      }));
    }

    const maxValue = values.reduce((max, value) => Math.max(max, value.value), 0);

    return values.map((value) => ({
      ...value,
      percentage: Math.round((value.value * 100) / maxValue),
      tooltip: this.composeTooltip(value),
      showTrack: value.hasValue,
    }));
  }

  private composeTooltip(value) {
    if (!this.showTooltip) {
      return;
    }

    const tooltip = value.value + (this.usePercentage ? '%' : '');
    if (this.orientation === 'horizontal') {
      return tooltip;
    }
    if (this.orientation === 'vertical') {
      return value.caption || tooltip;
    }
  }
}
